import { Box, BoxProps } from "@chakra-ui/react";

interface ProgressBarProps extends BoxProps {
  value: number;
  max: number;
}

export default function ProgressBar(props: ProgressBarProps) {
  const { value = 0, max = 10 } = props;

  return (
    <Box width="100%" height="10px" bg="#F2F4F3" borderRadius="20px" overflow="hidden">
      <Box
        w="var(--progress, 0%)"
        borderRadius="20px"
        bg="secondary.default"
        h="100%"
        transition="width 500ms cubic-bezier(0.35, 0.04, 0, 0.98)"
        willChange="width"
        sx={{ "--progress": `${(value / max) * 100}%` }}
      />
    </Box>
  );
}
